import styled from 'styled-components';

// Components
import { Typography } from '../Typography';

// Types
import { ContainerProps } from './types';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 27rem;
  border-radius: 0.5rem;
  padding: 0.3rem 1.3rem;
`;

export const ContainerInput = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 3.5rem;
  margin-bottom: 0.1rem;
  ${(props) =>
    !props.lastElement && {
      borderBottom: `0.1rem solid ${props.theme.colors.paleDarkGrey}`,
    }}
`;

export const Text = styled(Typography)`
  margin: 0 1rem;
  padding: 1rem 0;
  white-space: nowrap;
  overflow-x: scroll;
`;

export const SmallContainer = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
`;

export const ContainerRemoveIcon = styled.img`
  display: flex;
  width: ${({ theme }) => theme.spacing.xs};
  height: 1.75rem;
  cursor: pointer;
`;

export const ContainerFileIcon = styled(ContainerRemoveIcon)`
  margin-top: 0.3rem;
  cursor: auto;
`;

/** Espejo del de `InputLoadImages`: misma fila, misma miniatura. */
export const Thumbnail = styled.img`
  width: 4.8rem;
  height: 4.8rem;
  object-fit: cover;
  border-radius: 0.4rem;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.paleDarkGrey};
`;
